import bongdanetInRedGif from "@/assets/images/bongdanet_in_red.gif";
import bongdanetLineupIcon from "@/assets/images/bongdanet_lineup.svg";
import bongdanetCornerFlagPng from "@/assets/images/bongdanet_flag_corner.png";

import MobileOddsSlide from "./FootballOddsMobileOddsSlide";

export default function FootballOddsMobileRow({
  league,
  match,

  formattedGio,
  leagueShort,
  leagueBg,

  isLive,
  minuteText,

  currentHomeScore,
  currentAwayScore,
  currentHomeHalfScore,
  currentAwayHalfScore,
  currentHomeCorner,
  currentAwayCorner,
  homeYellow,
  awayYellow,
  homeRed,
  awayRed,

  otherCount,
  handleOtherOddsClick,

  openTipsWithTab,

  mobileOddsCarouselRef,
  mobileOddsSlideIndex,
  setMobileOddsSlideIndex,

  h1Handicap,
  h1Ou,
  h11x2,
  ft,
  ft1x2,
}) {
  return (
    <tr
      className="md:hidden"
      id={`tb_${match?.id}`}
      data-league={league?.id ?? match?.league?.id ?? match?.leagueId ?? ""}
    >
      <td
        colSpan={8}
        className="border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-top"
      >
        <div className="w-full text-[12px] leading-[18px]">
          <div className="grid w-full grid-cols-[1fr_35px_35px_minmax(140px,1fr)] items-start">
            <div className="min-w-0 px-1 py-1">
              <div className="flex items-center gap-1">
                <span className="text-[var(--theme-text)]">{formattedGio}</span>
                <span
                  className="ml-[6px] font-medium"
                  style={{ color: leagueBg }}
                >
                  {leagueShort}
                </span>
              </div>

              <div className="mt-1 flex items-center gap-1">
                <span className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-left text-[12px] leading-[22.5px]">
                  {match.homeName}
                </span>
                {Number(homeRed ?? 0) > 0 ? (
                  <span className="football-card-red inline-flex h-[14px] w-[10px] items-center justify-center rounded-[2px] text-center text-[9px]">
                    {homeRed}
                  </span>
                ) : null}
                {Number(homeYellow ?? 0) > 0 ? (
                  <span className="football-card-yellow inline-flex h-[14px] w-[10px] items-center justify-center rounded-[2px] text-center text-[9px]">
                    {homeYellow}
                  </span>
                ) : null}
              </div>

              <div className="mt-1 flex items-center gap-1">
                <span className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-left text-[12px] font-bold leading-[22.5px]">
                  {match.awayName}
                </span>
                {Number(awayRed ?? 0) > 0 ? (
                  <span className="football-card-red inline-flex h-[14px] w-[10px] items-center justify-center rounded-[2px] text-center text-[9px]">
                    {awayRed}
                  </span>
                ) : null}
                {Number(awayYellow ?? 0) > 0 ? (
                  <span className="football-card-yellow inline-flex h-[14px] w-[10px] items-center justify-center rounded-[2px] text-center text-[9px]">
                    {awayYellow}
                  </span>
                ) : null}
              </div>

              {otherCount > 0 ? (
                <div className="mt-1">
                  <button
                    type="button"
                    className="border-0 border-none bg-transparent p-0 text-left text-[12px] leading-[18px] text-[var(--theme-text-muted)] underline"
                    onClick={handleOtherOddsClick}
                  >
                    Kèo khác +{otherCount}
                  </button>
                </div>
              ) : null}
            </div>

            <div className="relative flex flex-col items-center justify-start py-1.5 text-center text-[var(--text-half-score)]">
              {isLive ? (
                <>
                  <div className="h-[22.5px] font-semibold leading-[22.5px]">
                    H1
                  </div>
                  <div className="h-[22.5px] leading-[22.5px]">
                    {currentHomeHalfScore ?? 0}
                  </div>
                  <div className="h-[22.5px] leading-[22.5px]">
                    {currentAwayHalfScore ?? 0}
                  </div>
                </>
              ) : (
                <>
                  <div className="h-[22.5px]" />
                  <div className="h-[22.5px]" />
                  <div className="h-[22.5px]" />
                </>
              )}
            </div>

            <div className="flex flex-col items-center justify-start py-1.5 text-center">
              {isLive ? (
                <>
                  <i className="status football-live-minute flex h-[22.5px] items-center justify-center gap-1 not-italic text-[9px] leading-[22.5px]">
                    <span>{minuteText || "Live"}</span>
                    <img
                      className="inline-block align-middle"
                      src={bongdanetInRedGif}
                      alt=""
                      aria-hidden
                    />
                  </i>

                  <div className="flex flex-col items-center justify-center">
                    <span className="block h-[22.5px] w-full rounded-[4px] bg-transparent text-center text-[12px] font-bold leading-[22.5px] text-orange-500">
                      {currentHomeScore ?? 0}
                    </span>
                    <span className="block h-[22.5px] w-full rounded-[4px] bg-transparent text-center text-[12px] font-bold leading-[22.5px] text-orange-500">
                      {currentAwayScore ?? 0}
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="h-[22.5px]" />
                  <div className="h-[22.5px]" />
                  <div className="h-[22.5px]" />
                </>
              )}
            </div>

            <div className="py-1">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-1 text-[var(--theme-text)]">
                  <img
                    src={bongdanetCornerFlagPng}
                    alt=""
                    className="inline-block h-[12px] w-[12px] object-contain"
                    aria-hidden
                  />
                  <span>
                    {(currentHomeCorner ?? 0) || (currentAwayCorner ?? 0)
                      ? `${currentHomeCorner ?? 0} - ${currentAwayCorner ?? 0}`
                      : " - "}
                  </span>
                </div>
                <button
                  type="button"
                  className="border-0 border-none bg-transparent p-0"
                  onClick={openTipsWithTab("form")}
                  title="Lineup"
                >
                  <img src={bongdanetLineupIcon} width="16" height="16" alt="" />
                </button>
              </div>

              <div
                ref={mobileOddsCarouselRef}
                className="mt-1 overflow-x-auto scroll-smooth snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
                onScroll={(e) => {
                  const el = e.currentTarget;
                  const w = el.clientWidth || 1;
                  const idx = Math.round(el.scrollLeft / w);
                  if (idx !== mobileOddsSlideIndex) setMobileOddsSlideIndex(idx);
                }}
              >
                <div className="flex w-full min-w-full">
                  <MobileOddsSlide
                    rows={[
                      {
                        label: "Chấp H1",
                        a: h1Handicap.home,
                        aTrend: h1Handicap.homeTrend,
                        b: h1Handicap.line,
                        c: h1Handicap.away,
                        cTrend: h1Handicap.awayTrend,
                      },
                      {
                        label: "Tài xỉu H1",
                        a: h1Ou.over,
                        aTrend: h1Ou.overTrend,
                        b: h1Ou.ouLine,
                        c: h1Ou.under,
                        cTrend: h1Ou.underTrend,
                      },
                      {
                        label: "1x2 H1",
                        a: h11x2.home,
                        aTrend: h11x2.homeTrend,
                        b: h11x2.draw,
                        bTrend: h11x2.drawTrend,
                        c: h11x2.away,
                        cTrend: h11x2.awayTrend,
                      },
                    ]}
                  />

                  <MobileOddsSlide
                    rows={[
                      {
                        label: "Chấp TT",
                        a: ft.home,
                        aTrend: ft.homeTrend,
                        b: ft.line,
                        c: ft.away,
                        cTrend: ft.awayTrend,
                      },
                      {
                        label: "Tài xỉu TT",
                        a: ft.over,
                        aTrend: ft.overTrend,
                        b: ft.ouLine,
                        c: ft.under,
                        cTrend: ft.underTrend,
                      },
                      {
                        label: "1x2 TT",
                        a: ft1x2.home,
                        aTrend: ft1x2.homeTrend,
                        b: ft1x2.draw,
                        bTrend: ft1x2.drawTrend,
                        c: ft1x2.away,
                        cTrend: ft1x2.awayTrend,
                      },
                    ]}
                  />
                </div>
              </div>

              <div className="flex shrink-0 items-center justify-center gap-1.5 py-2">
                {[
                  { label: "Hiệp 1", idx: 0 },
                  { label: "Cả Trận", idx: 1 },
                ].map((d) => {
                  const active = mobileOddsSlideIndex === d.idx;
                  return (
                    <button
                      key={d.idx}
                      type="button"
                      aria-label={d.label}
                      className={[
                        "p-0 border-0 flex-shrink-0 min-w-[5px] min-h-[5px] w-[5px] h-[5px] rounded-full box-border transition-colors",
                        active
                          ? "bg-[var(--theme-highlight,#0B71F9)]"
                          : "bg-[var(--theme-border)]",
                      ].join(" ")}
                      onClick={() => {
                        const el = mobileOddsCarouselRef.current;
                        if (!el) return;
                        const w = el.clientWidth || 0;
                        el.scrollTo({ left: d.idx * w, behavior: "smooth" });
                        setMobileOddsSlideIndex(d.idx);
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
}

